// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MRDemoPage styles */
.mr-demo-container {
    background-color: #FFFFFF;
    min-height: 100vh;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.mr-demo-title {
    color: #2D3E50;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
}

.mr-demo-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 20px;
    padding: 20px;
    width: 100%;
    max-width: 1200px;
}

.furniture-item {
    text-align: center;
    background-color: #F9FAFB;
    border-radius: 10px;
    padding: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.furniture-item img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin-bottom: 10px;
}

.furniture-item span {
    font-size: 16px;
    color: #2D3E50;
    font-weight: 500;
}

.mr-demo-button-container {
    text-align: center;
    margin-top: 30px;
    width: 100%;
}

.mr-demo-button {
    padding: 12px 24px;
    background-color: #d946ef;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    transition: background-color 0.3s ease;
    width: 100%;
    max-width: 300px;
}

.mr-demo-button:hover {
    background-color: #c135d8;
}

.mr-demo-loading, .mr-demo-error {
    text-align: center;
    padding: 20px;
    font-size: 18px;
    color: #2D3E50;
}

.mr-demo-error {
    color: #e63946;
}

/* Responsive styles for mobile */
@media (max-width: 768px) {
    .mr-demo-container {
        padding: 15px;
    }

    .mr-demo-title {
        font-size: 24px;
        margin-bottom: 15px;
    }

    .mr-demo-grid {
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        gap: 15px;
        padding: 15px;
    }

    .furniture-item {
        padding: 10px;
    }

    .furniture-item img {
        margin-bottom: 8px;
    }

    .furniture-item span {
        font-size: 14px;
    }

    .mr-demo-button {
        padding: 10px 20px;
        font-size: 15px;
        max-width: 250px;
    }

    .mr-demo-loading, .mr-demo-error {
        font-size: 16px;
        padding: 15px;
    }
}

@media (max-width: 480px) {
    .mr-demo-container {
        padding: 10px;
    }

    .mr-demo-title {
        font-size: 20px;
        margin-bottom: 10px;
    }

    .mr-demo-grid {
        grid-template-columns: 1fr;
        gap: 12px;
        padding: 10px;
    }

    .furniture-item {
        padding: 8px;
    }

    .furniture-item img {
        border-radius: 6px;
        margin-bottom: 6px;
    }

    .furniture-item span {
        font-size: 13px;
    }

    .mr-demo-button {
        padding: 8px 16px;
        font-size: 14px;
        max-width: 200px;
    }

    .mr-demo-loading, .mr-demo-error {
        font-size: 14px;
        padding: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Css/MRDemoPage.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,aAAa;IACb,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,iCAAiC;AACjC;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,4DAA4D;QAC5D,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;AACJ","sourcesContent":["/* MRDemoPage styles */\n.mr-demo-container {\n    background-color: #FFFFFF;\n    min-height: 100vh;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.mr-demo-title {\n    color: #2D3E50;\n    font-size: 28px;\n    font-weight: bold;\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n.mr-demo-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 20px;\n    padding: 20px;\n    width: 100%;\n    max-width: 1200px;\n}\n\n.furniture-item {\n    text-align: center;\n    background-color: #F9FAFB;\n    border-radius: 10px;\n    padding: 15px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.furniture-item img {\n    max-width: 100%;\n    height: auto;\n    border-radius: 8px;\n    margin-bottom: 10px;\n}\n\n.furniture-item span {\n    font-size: 16px;\n    color: #2D3E50;\n    font-weight: 500;\n}\n\n.mr-demo-button-container {\n    text-align: center;\n    margin-top: 30px;\n    width: 100%;\n}\n\n.mr-demo-button {\n    padding: 12px 24px;\n    background-color: #d946ef;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: 600;\n    transition: background-color 0.3s ease;\n    width: 100%;\n    max-width: 300px;\n}\n\n.mr-demo-button:hover {\n    background-color: #c135d8;\n}\n\n.mr-demo-loading, .mr-demo-error {\n    text-align: center;\n    padding: 20px;\n    font-size: 18px;\n    color: #2D3E50;\n}\n\n.mr-demo-error {\n    color: #e63946;\n}\n\n/* Responsive styles for mobile */\n@media (max-width: 768px) {\n    .mr-demo-container {\n        padding: 15px;\n    }\n\n    .mr-demo-title {\n        font-size: 24px;\n        margin-bottom: 15px;\n    }\n\n    .mr-demo-grid {\n        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n        gap: 15px;\n        padding: 15px;\n    }\n\n    .furniture-item {\n        padding: 10px;\n    }\n\n    .furniture-item img {\n        margin-bottom: 8px;\n    }\n\n    .furniture-item span {\n        font-size: 14px;\n    }\n\n    .mr-demo-button {\n        padding: 10px 20px;\n        font-size: 15px;\n        max-width: 250px;\n    }\n\n    .mr-demo-loading, .mr-demo-error {\n        font-size: 16px;\n        padding: 15px;\n    }\n}\n\n@media (max-width: 480px) {\n    .mr-demo-container {\n        padding: 10px;\n    }\n\n    .mr-demo-title {\n        font-size: 20px;\n        margin-bottom: 10px;\n    }\n\n    .mr-demo-grid {\n        grid-template-columns: 1fr;\n        gap: 12px;\n        padding: 10px;\n    }\n\n    .furniture-item {\n        padding: 8px;\n    }\n\n    .furniture-item img {\n        border-radius: 6px;\n        margin-bottom: 6px;\n    }\n\n    .furniture-item span {\n        font-size: 13px;\n    }\n\n    .mr-demo-button {\n        padding: 8px 16px;\n        font-size: 14px;\n        max-width: 200px;\n    }\n\n    .mr-demo-loading, .mr-demo-error {\n        font-size: 14px;\n        padding: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
